module.exports = __webpack_public_path__ + "assets/img/wxpay.6a2c49b4.svg";